import React, { Component } from 'react';
import $ from 'jquery';
import { useNavigate } from 'react-router-dom';
import { login_check } from './include/Common';

class Header extends Component {

  componentDidMount() {
    //console.log('header');
    const retLogin = login_check().then(isLogin => {
      //console.log('login check = ' + isLogin);
    });
    
    /*
    if(window.Swiper){
      const wordRecommandSwiper=new window.Swiper(".recommend-word-list",{
        slidesPerView:"auto",
        spaceBetween:6,
        freeMode:!0,
        scrollbar:{
          el:".recommend-word-list .swiper-scrollbar",
          draggable:!0,
          breakpoints:{480:{spaceBetween:10}}
        }
      })
      ,wordRemindSwiper=new window.Swiper(".wordSwiper .swiper-container",{
        speed:1e3,
        grabCursor:!0, 
        loop:!1,
        slidesPerView:"auto",
        centeredSlidesBounds:!0,spaceBetween:16
      }),
      searchResultSwiper=new window.Swiper(".search-result-card .swiper-container",{
        slidesPerView:"auto",
        speed:1e3,
        grabCursor:!0,
        loop:!1,
        spaceBetween:16,
        threshold:20,
        slideToClickedSlide:!0
      })
      ,wordUsageSwiper=new window.Swiper(".word-usage-swiper .swiper-container",{
        loop:!0,
        autoplay:{
          delay:5e3,
          disableOnInteraction:!1
        },
        effect:"fade",
        fadeEffect:{
          crossFade:!0
        },
        speed:500,
        grabCursor:!0,
        autoHeight:!0,
        pagination:{
          el:".word-usage-swiper .swiper-pagination",clickable:!0
        }
      })
    } else {
      console.error('Swiper가 로드되지 않았습니다.');
    }
*/
    /*
        const navBtn = $(".header .search-btn")
          , navLayer = $(".search-layer")
          , navDimmed = $(".layer-dimmed")
          , navSearchLayerInput = $("#searchLayerInput");
    
    
        $(".header .search-btn").on("click", function (e) {
          //$(this).hasClass("active")?navClose():navOpen()
          if ($(this).hasClass("active")) {
            navClose();
          } else {
            navOpen();
          }
        });
        $("#layerDimm").on("click", function (e) {
          console.log('laydm');
          navClose();
        }); 
        function navOpen() {
          return navBtn.find("span").text("검색창 닫기"), $("html").css("overflow", "hidden"),
            setTimeout(() => { $(navSearchLayerInput).focus() }, 100), navBtn.addClass("active"), navLayer.addClass("active"), navDimmed.stop().show(), !1
        }
        function navClose() {
          console.log('navClose');
          return navBtn.find("span").text("검색창 열기"),
            $("html").css("overflow", "auto"),
            navBtn.removeClass("active"),
            navLayer.removeClass("active"),
            navDimmed.stop().hide(),
            navSearchLayerInput.val("").blur(),
            !1
        }
    */
  }

  render() {
    const path = this.props.location.pathname;

    const isHiddenSearchBtn = (path.startsWith("/Search") || path.startsWith("/WordList"));

    const pocketUrl = process.env.REACT_APP_POCKET_WWW;
    
    return (
      <div>
        <header className="header" id="header">
          <a href={pocketUrl} className="logo" title="지식포켓">
            <svg xmlns="http://www.w3.org/2000/svg" width="108" height="29" viewBox="0 0 108 29" fill="none">
              <g>
                <path d="M10.074 4.95508V6.8178C10.0253 7.48741 9.9522 8.14484 9.84257 8.80227C9.73294 9.4597 9.57458 10.1171 9.39186 10.7746C9.22132 11.3102 9.0386 11.8459 8.83152 12.3573C8.63661 12.8686 8.41735 13.3678 8.1859 13.8547C8.24681 13.9156 8.29554 13.9643 8.35644 14.0008C8.41735 14.0495 8.47826 14.0861 8.55134 14.1348C8.78279 14.3539 9.00206 14.5609 9.20914 14.7678C9.4284 14.9748 9.63549 15.1818 9.85475 15.3766C10.0375 15.5957 10.2324 15.8027 10.4273 16.034C10.6222 16.2531 10.8049 16.4723 10.9998 16.6914C11.0851 16.8254 11.1703 16.9471 11.2556 17.0688C11.3409 17.1906 11.4261 17.3123 11.5114 17.4219C11.5967 17.5558 11.682 17.6776 11.7794 17.7993C11.8769 17.9211 11.9621 18.0428 12.0474 18.1767L9.5624 20.8308C9.37968 20.5508 9.19696 20.2708 9.00206 20.0151C8.81933 19.7594 8.63661 19.5038 8.46607 19.2725C8.27117 19.0533 8.06409 18.8463 7.86919 18.6272C7.67429 18.4081 7.4672 18.2011 7.2723 17.9819C7.10176 17.848 6.93122 17.7141 6.78505 17.5802C6.62669 17.4341 6.46833 17.288 6.30997 17.1297C6.17598 17.3123 6.05416 17.495 5.92017 17.6654C5.78617 17.8359 5.65218 18.0063 5.53037 18.1524C5.07966 18.7124 4.60458 19.2238 4.10515 19.6864C3.61789 20.1612 3.10627 20.5873 2.59466 20.9891L0.012207 18.2133C0.414192 17.8967 0.803996 17.5558 1.18162 17.2028C1.55924 16.8375 1.92468 16.4601 2.27794 16.0827C2.61902 15.7175 2.93574 15.3279 3.24027 14.9383C3.5448 14.5487 3.83716 14.1348 4.11733 13.7086C4.37314 13.2947 4.61676 12.8808 4.83603 12.4425C5.05529 12.0164 5.25019 11.5781 5.42073 11.1154C5.57909 10.6893 5.71309 10.251 5.81054 9.78841C5.92017 9.33795 6.00544 8.86314 6.05416 8.4005H0.743089V4.97943H10.074V4.95508ZM12.7296 21.7804V4.57767H16.6885V21.7926H12.7296V21.7804Z" fill="black" />
                <path d="M19.2466 11.9555C20.0627 11.4807 20.7571 10.9937 21.3296 10.4824C21.9021 9.97103 22.365 9.43535 22.6939 8.87531C22.9984 8.31528 23.2177 7.69437 23.3517 7.01259C23.4857 6.33081 23.5466 5.57599 23.4979 4.74811H27.1767C27.1767 5.46641 27.1401 6.13602 27.067 6.75693C26.9939 7.39001 26.8843 7.97439 26.7503 8.53442C27.1036 8.75357 27.469 8.96054 27.8223 9.19186C28.1755 9.411 28.5288 9.65449 28.8699 9.91016C29.2597 10.2389 29.6373 10.5919 30.0149 10.9694C30.3925 11.3468 30.7702 11.7607 31.16 12.199L28.4679 14.6096C28.1268 14.1835 27.7857 13.7939 27.4568 13.4286C27.1279 13.0756 26.8112 12.7469 26.4945 12.4668C26.3849 12.3938 26.2752 12.3207 26.1778 12.2477C26.0803 12.1746 25.9829 12.0894 25.8732 12.0285C25.7636 11.9555 25.654 11.8825 25.5443 11.8094C25.4347 11.7364 25.3373 11.6511 25.2398 11.5903C24.7526 12.1868 24.1922 12.7469 23.5588 13.2582C22.9254 13.7695 22.2067 14.2322 21.4149 14.6461L19.2588 11.9677L19.2466 11.9555ZM32.5365 21.8048V18.9437H20.9885V15.5227H36.2883V21.8048H32.5486H32.5365ZM32.5608 14.6704V4.57767H36.2883V14.6704H32.5608Z" fill="black" />
                <path d="M63.8304 17.5071C63.8304 14.3417 65.2921 12.3207 68.7882 12.3207C72.2843 12.3207 73.8069 14.3417 73.8069 17.5071C73.8069 20.6725 72.2721 22.6935 68.7882 22.6935C65.3043 22.6935 63.8304 20.6725 63.8304 17.5071ZM71.1757 17.5071C71.1757 15.6931 70.2987 14.707 68.7882 14.707C67.2777 14.707 66.4616 15.6931 66.4616 17.5071C66.4616 19.3212 67.2777 20.3073 68.7882 20.3073C70.2987 20.3073 71.1757 19.3212 71.1757 17.5071Z" fill="black" />
                <path d="M84.0636 20.4899C83.1257 22.0361 82.0293 22.6814 79.593 22.6692C76.633 22.6692 74.4525 21.1108 74.4525 17.6532C74.4525 14.1956 76.5112 12.3694 79.52 12.3694C81.7613 12.3694 83.2596 13.4165 84.0636 15.3035L81.8466 16.2897C81.3837 15.267 80.7259 14.8409 79.6052 14.8409C78.0947 14.8409 77.169 15.961 77.169 17.6532C77.169 19.2238 78.2044 20.1977 79.6905 20.1977C80.8112 20.1977 81.5421 19.7838 82.0171 19.029L84.088 20.4777L84.0636 20.4899Z" fill="black" />
                <path d="M84.9529 9.17968H87.6571V16.7888L90.13 12.5886H93.2971L90.4345 17.2393C90.7634 17.361 91.0679 17.5437 91.3481 17.7506C92.4444 18.5785 93.09 19.8081 93.224 22.4257H90.5319C90.4345 19.9908 89.594 19.2238 88.2906 19.2238H87.6693V22.4257H84.9651V9.17968H84.9529Z" fill="black" />
                <path d="M103.188 20.4899C102.238 21.9022 100.959 22.6692 98.7178 22.6692C95.7577 22.6692 93.5773 20.9526 93.5773 17.495C93.5773 14.0374 95.4532 12.3694 98.6447 12.3694C101.836 12.3694 103.298 14.5852 103.298 17.3854V18.5907H96.5008V18.6516C96.6104 19.6377 97.6215 20.356 98.8153 20.356C99.9359 20.356 100.74 19.8568 101.215 19.1142L103.201 20.4777L103.188 20.4899ZM100.703 16.2775V16.1679C100.703 15.5105 100.131 14.6704 98.73 14.6704C97.2439 14.6704 96.5617 15.547 96.5617 16.1801V16.2775H100.703Z" fill="black" />
                <path d="M104.236 14.9748H103.359V12.5886H104.236V9.10663H107.025V12.5886H108V14.9748H107.025V19.0777C107.025 20.2708 107.086 20.5873 107.756 21.0378L107.293 23.0588C105.966 23.0223 105.235 22.8153 104.845 22.3526C104.394 21.8291 104.236 21.33 104.236 19.869V14.9626V14.9748Z" fill="black" />
                <path d="M40.3934 11.2372V29H46.4476V11.2372H40.3934Z" fill="#4553E7" />
                <path d="M51.6368 22.4744C57.8464 22.4744 62.8802 17.4433 62.8802 11.2372C62.8802 5.03106 57.8464 0 51.6368 0C45.4273 0 40.3934 5.03106 40.3934 11.2372C40.3934 17.4433 45.4273 22.4744 51.6368 22.4744Z" fill="#4553E7" />
                <path d="M51.6368 16.4236C54.5028 16.4236 56.8261 14.1016 56.8261 11.2372C56.8261 8.37283 54.5028 6.0508 51.6368 6.0508C48.7709 6.0508 46.4476 8.37283 46.4476 11.2372C46.4476 14.1016 48.7709 16.4236 51.6368 16.4236Z" fill="white" />
              </g>
            </svg>
          </a>
          {!isHiddenSearchBtn ? <button className="search-btn"><span className="sr-only">검색창 열기</span></button> : <div />}
        </header>
        <></>
        <div className="sr-only">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
            <g id="zzim">
              <path d="M2.26398 7.52576C2.25944 7.18913 2.28876 6.85313 2.35089 6.52283L2.42413 6.1947L2.42511 6.1908C2.6094 5.44752 2.97266 4.76225 3.48077 4.19373L3.70734 3.9574L3.71124 3.95349C4.17241 3.49488 4.71717 3.12837 5.31671 2.87634L5.31769 2.87732C6.5244 2.38214 7.87711 2.38175 9.08429 2.87537H9.08527C9.64715 3.1132 10.1638 3.44569 10.6136 3.85779L10.6653 3.91931L10.68 3.93689L10.6956 3.95251L11.6468 4.90271L12.0003 5.25623L13.3196 3.93689L13.3343 3.91931L13.3821 3.86072C13.7757 3.49944 14.2207 3.19917 14.7025 2.97009L14.9144 2.87537C16.0464 2.41214 17.3066 2.38397 18.4544 2.79041L18.6829 2.87732C19.2074 3.09778 19.6902 3.40508 20.1116 3.78552L20.2894 3.95349L20.2952 3.95935C20.6085 4.26043 20.8725 4.60903 21.0784 4.99158L21.0833 4.99939L21.0872 5.0072C21.2501 5.28549 21.3833 5.57966 21.4847 5.88513L21.5755 6.1947C21.6595 6.52062 21.711 6.85428 21.7288 7.18982L21.7357 7.52576V7.53455C21.7391 8.27873 21.5683 9.01226 21.2386 9.67615L21.0872 9.95642L21.0804 9.96814C20.923 10.2554 20.7335 10.5237 20.5169 10.7689L20.2923 11.0062L12.0003 19.2982L3.71027 11.0082L3.48175 10.766C3.3349 10.5997 3.19926 10.4238 3.0755 10.2396L2.89874 9.9574C2.69421 9.58538 2.53429 9.19039 2.42316 8.78064H2.42413C2.31815 8.37526 2.26496 7.95565 2.26495 7.53259L2.26398 7.52576Z" stroke="currentColor" fill="currentColor" />
            </g>
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
            <g id="quote">
              <path d="M16 8.20697C16 10.7035 13.802 12 12.266 12C10.73 12 8.38 10.4976 8.38 7.68901C8.38 3.40375 11.7561 0.312064 14.1599 0C14.3372 0.312064 14.5684 0.778552 14.5684 0.778552C13.4948 1.2193 10.5273 3.27185 10.3753 5.14102C11.1924 4.61984 11.5471 4.36247 12.5225 4.36247C14.5684 4.36247 16 6.28311 16 8.20697Z" fill="currentColor" fillOpacity="0.6" />
              <path d="M3.88598 12C5.42201 12 7.61995 10.7035 7.61995 8.20697C7.61995 6.28311 6.18844 4.36247 4.14252 4.36247C3.16706 4.36247 2.81552 4.61984 1.99525 5.14102C2.14727 3.27185 5.1148 1.2193 6.18844 0.778552C6.18844 0.778552 5.95724 0.312064 5.77989 0C3.37609 0.312064 0 3.40375 0 7.68901C0 10.4976 2.34996 12 3.88598 12Z" fill="currentColor" fillOpacity="0.6" />
            </g>
          </svg>
        </div>
        <span id="layerDimm" className="layer-dimmed"></span>
      </div>
    );
  }
}

export default Header;      